import {
  CustomerDashboardEventStatus,
  EntryStatus,
  VehicleCurrentStatus,
} from "components/common/StatusBadge";
import DataTable from "components/common/table/DataTable";
import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { PLAN_OPTIONS } from "utils/constants";
import { formatUTCDate } from "utils/utils";

export const DATA = [
  {
    id: "#1",
    name: "Fahad Al-Harbi",
    store: "Al Ared, Riyadh",
    package: "Unlimited Shine",
    dateTime: "2025-12-31T12:39:58.083Z",
    licencePlate: "ABC 1234",
    status: -1,
  },
  {
    id: "#2",
    name: "Abdulrahman Al-Qahtani",
    store: "Al Ared, Riyadh",
    package: "Unlimited Protect",
    dateTime: "2025-12-27T12:19:58.083Z",
    licencePlate: "KSA 5678",
    status: 0,
  },
  {
    id: "#3",
    name: "Mohammed Al-Mutairi",
    store: "Al Ared, Riyadh",
    package: "Unlimited Works",
    dateTime: "2025-12-29T12:29:58.083Z",
    licencePlate: "RDX 9087",
    status: 4,
  },
  {
    id: "#4",
    name: "Saud Al-Dosari",
    store: "Al Ared, Riyadh",
    package: "One Time Protect",
    dateTime: "2025-12-31T12:39:58.083Z",
    licencePlate: "JED 3456",
    status: 5,
  },
  {
    id: "#5",
    name: "Yasser Al-Ghamdi",
    store: "Al Ared, Riyadh",
    package: "Unlimited Shine",
    dateTime: "2025-12-31T12:39:58.083Z",
    licencePlate: "DAM 7788",
    status: 7,
  },
];

const RecentActivity = () => {
  const { t } = useTranslation();
  const listData = useSelector((state) => state.Dashboard?.lists);

  const columns = useMemo(
    () => [
      {
        header: t("Name"),
        key: "userId",
        render: (value) => value?.name || "-",
      },
      {
        header: t("Phone"),
        key: "userId",
        render: (value) => (
          <span className="ltr_text">{value?.phone || "-"}</span>
        ),
      },
      {
        header: t("Plan Type"),
        key: "planId",
        render: (value) => {
          const name = PLAN_OPTIONS?.find(
            (option) => option?.value === value?.planType,
          )?.name;
          return name ? t(name) : value?.planType || "-";
        },
      },
      {
        header: t("Date & Time"),
        key: "createdAt",
        render: (value) => (
          <div className="ltr_text">{formatUTCDate(value)}</div>
        ),
      },
      {
        header: t("Car Number"),
        key: "licencePlateNumber",
        render: (value) => <p>{value}</p>,
      },
      {
        header: t("Status"),
        key: "status",
        render: (value) => (
          <CustomerDashboardEventStatus status={value} t={t} />
        ),
      },
    ],
    [t],
  );

  return (
    <div className="recent_activity">
      <h2 className="fs_20 mb-3">{t("Recent Activities")}</h2>
      {listData?.lists && (
        <DataTable
          columns={columns}
          data={listData?.lists}
          t={t}
          className=""
        />
      )}
    </div>
  );
};

export default RecentActivity;
